import {
  Create,
  Datagrid,
  Edit,
  List,
  SimpleForm,
  TextField,
  TextInput,
  required,
  useRecordContext,
} from "react-admin";
import { ReferenceArrayInput, EditToolbar } from "@components";

interface Group {
  id: number;
  name: string;
  groupUsersIds: number[];
}

const validateRequired = [required()];

export const GroupList = () => (
  <List>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="id" sortable={false} />
      <TextField source="name" sortable={false} />
    </Datagrid>
  </List>
);

export const GroupCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" validate={validateRequired} fullWidth />
      <ReferenceArrayInput source="groupUsersIds" reference="user" />
    </SimpleForm>
  </Create>
);

const GroupEditForm = () => {
  const record = useRecordContext<Group>();

  const defaultUserIds = record?.groupUsersIds || [];

  return (
    <SimpleForm toolbar={<EditToolbar showDeleteButton={false} />}>
      <TextInput source="name" validate={validateRequired} fullWidth />
      <ReferenceArrayInput 
        source="groupUsersIds" 
        reference="user"
        defaultValue={defaultUserIds}
      />
    </SimpleForm>
  );
};

export const GroupEdit = () => {
  return (
    <Edit mutationMode="pessimistic">
      <GroupEditForm />
    </Edit>
  );
};